import { Component, inject } from '@angular/core';
import { SaveCloseItemActionComponent } from '@ntap/common';
import { Item, ListViewProviderDirective } from '@ntap/core';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-save-close-refresh-item-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./save-close-refresh-action.component.scss']
})
export class SaveCloseRefreshItemActionComponent extends SaveCloseItemActionComponent {
  private listViewProvider = inject(ListViewProviderDirective);

  protected override doExecuteWithItem(item: Item): Observable<any> {
    return super.doExecuteWithItem(item).pipe(
      tap(() => {
        this.listViewProvider.refresh();
      })
    );
  }
}
